export default {
  siblings: (elem, match) => {
    return [...elem.parentNode.children].filter(a => (a != elem && match ? a.matches(match) : true));
  },

  next: (elem, match) => {
    let ref = elem;
    let ret = null;
    while (ref.nextElementSibling && ret == null) {
      ref = ref.nextElementSibling;
      if (match) {
        ret = ref.matches(match) ? ref : null;
      } else {
        ret = ref;
      }
    }
    return ret;
  },

  prev: (elem, match) => {
    let ref = elem;
    let ret = null;
    while (ref.previousElementSibling && ret == null) {
      ref = ref.previousElementSibling;
      if (match) {
        ret = ref.matches(match) ? ref : null;
      } else {
        ret = ref;
      }
    }
    return ret;

  },
};